import { AccountId, UserId } from '../types/types'
import { atomFamily, selectorFamily } from 'recoil'
import { api } from '../utils/api'

interface IAccountUserId {
  readonly accountId: AccountId
  readonly userId: UserId
}

const fetchAccountUsers = async (accountId: AccountId): Promise<IAccountUserId[]> => {
  const { data } = await api.get(`/account/${accountId}/user/list`)

  return data.accountUsers
}

export const accountUserIdsState = atomFamily<IAccountUserId[], AccountId>({
  key: 'accountUserIdsState',
  default: selectorFamily({
    key: 'accountUserIdsState/Default',
    //get: async (): Promise<IUser[]> => fetchUsers(),
    get: (accountId: AccountId) => async (): Promise<IAccountUserId[]> =>
      fetchAccountUsers(accountId),
  }),
})